import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";

class FeeCard extends Component {
  render() {
    var total = 0;
    return (
      <div className="border shadow-sm rounded mb-3 p-3">
        <div className="th-12 th-medium th-cap">{this.props.title}</div>
        <div className="th-12 th-grey">Due Date: {this.props.date}</div>
        <div className="mt-2">
          <Accordion defaultActiveKey={null}>
            <div>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                style={{
                  padding: 0,
                  textDecoration: "none",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="th-12 th-black text-left">
                      Total: <span className="th-roboto">₹</span>{" "}
                      {this.props.amount} | Balance:{" "}
                      <span className="th-roboto">₹</span> {this.props.balance}
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="th-grey th-12 pr-1">Details</div>
                    <i
                      className="fa fa-angle-down th-primary"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <div className="mt-2">
                  {this.props.detail?.map((item, index) => {
                    total += item.fee_type_total;
                    return (
                      <div
                        key={index}
                        className="d-flex justify-content-between"
                      >
                        <div className="th-12 th-grey th-medium text-left">
                          {item.fee_type.type_name}:
                        </div>
                        <div className="th-12 th-grey text-left">
                          <span className="th-roboto">₹</span>{" "}
                          {item.fee_type_total}
                        </div>
                      </div>
                    );
                  })}
                  <div className="d-flex justify-content-between">
                    <div className="th-12 th-grey th-medium text-left">
                      Total:
                    </div>
                    <div className="th-12 th-grey text-left">
                      <span className="th-roboto">₹</span> {total}
                    </div>
                  </div>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
    );
  }
}
export default FeeCard;
